import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Support = () => {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', comments: '' });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch('https://api.namapages.com/support', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
    } catch (err) {
      console.error('Support form submission error:', err);
    }
    setSubmitted(true);
  };

  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: '0.5rem' }}>
      {/* Header card */}
      <div className="np-panel" style={{
        background: 'linear-gradient(135deg, #F0C040 0%, #FFE082 50%, #E8A800 100%)',
        border: '2px solid var(--gold-deep)',
        boxShadow: '0 4px 18px rgba(184,134,11,0.25)',
        marginBottom: '1.5rem', textAlign: 'center', padding: '1.75rem 1.5rem'
      }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>🙏</div>
        <h1 style={{ fontFamily: 'var(--font-heading)', color: 'var(--brown-deep)', letterSpacing: '2px', margin: 0, fontSize: '1.5rem' }}>
          Support
        </h1>
        <p style={{ fontFamily: 'var(--font-body)', fontStyle: 'italic', color: 'var(--brown-mid)', opacity: 0.85, margin: '0.5rem 0 0', fontSize: '0.85rem' }}>
          We're here to help — reach out with your questions
        </p>
      </div>

      {submitted ? (
        <div className="np-panel" style={{ textAlign: 'center', padding: '3rem 2rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🪷</div>
          <h2 style={{ fontFamily: 'var(--font-heading)', color: 'var(--maroon-mid)', letterSpacing: '1px', marginBottom: '0.5rem' }}>
            Thank You
          </h2>
          <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', fontStyle: 'italic' }}>
            Your response has been received. We'll get back to you soon.
          </p>
          <Link to="/" className="np-btn" style={{ marginTop: '1.5rem', display: 'inline-flex' }}>
            🏠 Back to Home
          </Link>
        </div>
      ) : (
        <div className="np-panel">
          <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', marginBottom: '1.5rem', lineHeight: 1.7 }}>
            Please enter your name, email (optional), and your comments or questions below.{' '}
            <strong style={{ color: 'var(--maroon-mid)' }}>Do not enter sensitive information.</strong>{' '}
            Provide any additional details to help us support you.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="np-form-row">
              <label className="np-form-label">Name *</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                className="np-input"
                placeholder="Your name"
              />
            </div>

            <div className="np-form-row">
              <label className="np-form-label">Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="np-input"
                placeholder="Optional"
              />
            </div>

            <div className="np-form-row" style={{ alignItems: 'flex-start' }}>
              <label className="np-form-label" style={{ paddingTop: '0.55rem' }}>Comments *</label>
              <textarea
                name="comments"
                value={form.comments}
                onChange={handleChange}
                required
                rows={5}
                className="np-textarea"
                placeholder="Your questions or comments…"
              />
            </div>

            <hr className="np-divider-thin" />

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.75rem', marginTop: '0.5rem' }}>
              <Link to="/" className="np-btn np-btn-ghost" style={{ fontSize: '0.78rem' }}>
                ← Back to Home
              </Link>
              <button type="submit" className="np-btn np-btn-saffron" style={{ padding: '0.6rem 1.8rem', fontSize: '0.85rem', letterSpacing: '1px' }}>
                🙏 Submit
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default Support;
